export const missingNumbers = (
  numbers: number[],
  min: number,
  max: number
): number[] => {
  const missingNumbers = [];

  const sortNumbers = numbers.sort((a, b) => a - b);

  for (let index = min; index < max; index++) {
    const find = sortNumbers.indexOf(index);

    if (find === -1) {
      missingNumbers.push(index);
    }
  }

  return missingNumbers;
};
